// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__V9l52","title":"InfoRow_title__1FSGK"};